import { getAnalytics } from "@tm/insurance/analytics";
import { downloadPdfPost } from "@tm/insurance/utils";
import { FormattedText } from "@tm/static";
import React, { useState } from "react";
import {
  DownloadButton,
  DownloadButtonContainer,
  DropdownContent,
  DropdownModalContainer,
  OptionText,
  OptionWrapper,
  RadioButtonContainer,
  RadioButtonInner,
  RadioButtonSelected,
  RadioButtonUnselected,
  SeparatorLine,
} from "./MoreBenefits.style";

const analytics = getAnalytics();

interface DropdownModalProps {
  options: {
    id?: string;
    title: any;
    url?: string; // Keep for backward compatibility, but not used for downloads
    templateType?: string; // Maps to "with_price" or "without_price"
    ctaText?: any;
    defaultSelected?: boolean;
  }[];
  quoteId?: string; // Add quoteId for the new API endpoint
  onClose: () => void;
  csrfToken?: string;
}

const DropdownModal: React.FC<DropdownModalProps> = ({
  options,
  quoteId,
  onClose,
  csrfToken,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(() => {
    // Find the last option with defaultSelected: true, or fallback to first option
    let defaultOption = options[0];
    options.forEach((option) => {
      if (option.defaultSelected) {
        defaultOption = option;
      }
    });
    return defaultOption?.id || defaultOption?.url || "";
  });

  const handleDownload = async () => {
    if (selectedOption && quoteId) {
      // Find the selected option
      const selectedOptionData = options.find(
        (option) => (option.id || option.url) === selectedOption
      );

      if (selectedOptionData) {
        // Use the option ID as templateType (e.g., "with_price" or "without_price")
        const templateType =
          selectedOptionData.id ||
          selectedOptionData.templateType ||
          "with_price";

        const itineraryId =
          new URLSearchParams(window.location.search).get("itineraryId") || "";

        analytics?.trackListingEvents({
          actionType: `policy_downloaded_${
            templateType === "with_price" ? "with_price" : "without_price"
          }`,
        });
        await downloadPdfPost(quoteId, templateType, csrfToken, itineraryId);

        onClose();
      }
    }
  };

  return (
    <DropdownModalContainer>
      <DropdownContent>
        {options.map((option, index) => {
          const optionKey = option.id || option.url || `option-${index}`;
          return (
            <React.Fragment key={optionKey}>
              <OptionWrapper onClick={() => setSelectedOption(optionKey)}>
                <RadioButtonContainer>
                  {selectedOption === optionKey ? (
                    <RadioButtonSelected>
                      <RadioButtonInner />
                    </RadioButtonSelected>
                  ) : (
                    <RadioButtonUnselected />
                  )}
                </RadioButtonContainer>

                <OptionText>
                  <FormattedText value={option.title} />
                </OptionText>
              </OptionWrapper>

              {index < options.length - 1 && <SeparatorLine />}
            </React.Fragment>
          );
        })}
      </DropdownContent>

      <DownloadButtonContainer>
        <DownloadButton onClick={handleDownload}>DOWNLOAD</DownloadButton>
      </DownloadButtonContainer>
    </DropdownModalContainer>
  );
};

export default DropdownModal;
